import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { reportClientError } from '@/api/clientErrors'
import { router } from './router'
import { i18n } from './i18n'
import './style.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)

app.config.errorHandler = (err, _instance, info) => {
  const error = err instanceof Error ? err : new Error(String(err))
  reportClientError({
    message: error.message || String(err),
    source: 'client_js',
    url: window.location.href,
    stack: [info, error.stack].filter(Boolean).join('\n'),
  })
}

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  const error = reason instanceof Error ? reason : new Error(String(reason))
  reportClientError({
    message: error.message || String(reason),
    source: 'client_js',
    url: window.location.href,
    stack: error.stack,
  })
})

window.addEventListener('error', (event) => {
  const error = event.error instanceof Error ? event.error : undefined
  reportClientError({
    message: event.message || error?.message || 'window error',
    source: 'client_js',
    url: event.filename || window.location.href,
    stack: error?.stack,
  })
})

app.mount('#app')
